import { type ComponentPropsWithoutRef, forwardRef } from "react";
import { cn } from "../../styles/utils";

// import { textStyles } from "~/styles/typography";

export const commonStyles =
  "w-full px-5 py-4 rounded-lg transition-colors border";
export const variantStyles = {
  light: {
    enabled:
      "bg-white text-blue-dark placeholder:text-blue-dark60 border-blue-dark20",
    disabled:
      "bg-blue-dark20 text-blue-dark40 placeholder:text-blue-dark60 border-blue-dark20",
  },
  dark: {
    enabled:
      "bg-grey-light text-blue-dark border-blue-dark20 active:border-blue-200 placeholder:text-blue-100",
    disabled:
      "bg-grey-primaryExtra text-blue-dark border-blue-dark20 active:border-blue-200 placeholder:text-blue-100",
  },
};

type Props = {
  variant?: keyof typeof variantStyles;
  error?: string;
} & ComponentPropsWithoutRef<"input">;

const TextField = forwardRef<HTMLInputElement, Props>(function TextField(
  { variant = "light", className, error, ...props },
  ref
) {
  return (
    <div className="w-full">
      <input
        {...props}
        ref={ref}
        className={cn(
          // textStyles.sub2,
          commonStyles,
          props.disabled
            ? variantStyles[variant].disabled
            : variantStyles[variant].enabled,
          className,
          error && "border-red"
        )}
      />
      {error && <p className="text-red text-xs mt-1 px-3">{error}</p>}
    </div>
  );
});

export default TextField;
